module.exports = __webpack_public_path__ + "static/media/RotateRight.89737854.svg";